import styled, { css } from 'styled-components'
import { text } from '../styles/mixins/text'
import { BORDER_RADIUS, SPACING } from '../styles/mixins/constants'
import { color } from '../styles'

export const CELL_BORDER = css`
    border: 1px solid ${color.border.primary};
`

const CELL_STYLE = css`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    padding: ${SPACING[2]} ${SPACING[4]};
    background-color: ${color.background.content};
    border-bottom: 1px solid ${color.border.primary};
`

export const Table = styled.div`
    border-radius: ${BORDER_RADIUS};
    border: 1px solid ${color.border.primary};
    padding: 0px;
    display: flex;
    flex: 0 1 auto;
    min-height: 0;
    min-width: 0;
    max-width: min-content;
    flex-flow: column nowrap;
    overflow: auto;
`

export const HeaderRow = styled.div``

export const TableBody = styled.div`
    display: flex;
    flex-flow: column nowrap;
    flex: 0 1 auto;
    min-width: 0px;
    min-height: 0px;
    position: relative;
`

export const TableHeadCell = styled.div`
    ${CELL_STYLE}
    background-color: ${color.background.tableHeader};
    ${text('label', 'primary', 'text', 'bold')}
    color: ${color.brand.dark};
    white-space: pre-line;
    white-space: nowrap;
`

export const TableCell = styled.div`
    ${CELL_STYLE}
    ${text('paragraph', 'primary')}
`

export const TableRow = styled.div<{
    columnSize: string
    rowSize?: string
    defaultColumnSize?: string
    defaultRowSize?: string
    canSelect?: boolean
    isInverted?: boolean
    hasBottomBorder?: boolean
}>`
    display: grid;

    ${(p) =>
        p.columnSize &&
        `
  grid-template-columns: ${p.columnSize};
  `}
    ${(p) => p.defaultColumnSize && `grid-auto-columns: ${p.defaultColumnSize};`}
    ${(p) => p.defaultRowSize && `grid-auto-rows: ${p.defaultRowSize};`}
  ${(p) =>
        p.rowSize &&
        css`
            grid-template-rows: ${p.rowSize};
        `}

  ${(p) =>
        p.isInverted &&
        css`
            background-color: ${color.background.app};
        `}

  ${(p) =>
        p.hasBottomBorder &&
        css`
            border-bottom: 1px solid ${color.border.primary};
        `}
`
